/**
 * 错误信息转成Error对象
 * @param error
 */
import { isUndef } from '../verify';
export function getErrorObject(error) {
  if (isUndef(error)) {
    return new Error('');
  }
  if (error instanceof Error) {
    return error;
  }
  if (typeof error === 'string') {
    return new Error(error);
  }
  var str = error.toString();
  return new Error(str);
}
/**
 * 获取错误信息的string字符串
 * @param error
 */
export function getErrorMessage(error) {
  if (isUndef(error)) {
    return '';
  }
  if (error instanceof Error) {
    return error.stack ? error.stack : error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  return error.toString();
}
/**
 * 不同类型转成字符串
 * @param value
 * @param trimType 清除类型，只清除左边，左右两边，右边, 默认不做处理
 */
export function getStringFromAny(value, trimType) {
  if (isUndef(value) || value === '') {
    return '';
  }
  // 根据数据类型转成string
  var result;
  if (typeof value === 'string') {
    result = value;
  } else if (typeof value === 'number') {
    result = String(value);
  } else {
    result = JSON.stringify(value);
  }
  // 清除空格方式
  switch (trimType) {
    case 'start':
      return result.trimStart();
    case 'end':
      return result.trimEnd();
    case 'all':
      return result.trim();
    default:
      return result;
  }
}